/*REGEX for Content html for post*/
export const REGEX_AUDIOVIMEO = /audio_vimeo id="[\w]+"/g;
export const REGEX_SOUNDCLOUDPLAYLIST = /sc_playlist src=".*"/g;
export const REGEX_SOUNDCLOUDTRACK= /sc_track src=".*"/g;
export const REGEX_HTMLTAG = /<[^>]*>?/gm

/*REGEX for result by ElasticSearch Content*/
export const REGEX_TAG_MEDIA = /\[{0,1}(sc_track|sc_playlist|audio_vimeo)*.*\]/g;
export const REGEX_RM_BR_OR_URL =/<br\s*\/?>|url=.*]/g;